<template>
  <div class="flex-col justify-start page">
    <div class="flex-col justify-start group_3">
      <div class="flex-col group_4">
        <div class="flex-col space-y-14">
          <div class="flex-row justify-between items-center">
            <div class="flex-row space-x-6">
              <div class="shrink-0 section"></div>
              <span class="font_1 text_3">根系详细数据内容</span>
            </div>
            <div class="flex-row items-center space-x-6">
              <div class="shrink-0 section_2"></div>
              <span class="text_4">最后一次数据：2023/08/10</span>
            </div>
          </div>
          <div class="flex-col justify-start">
            <div class="flex-col space-y-12">
              <div class="flex-col items-center list-item space-y-14" v-for="(item, index) in items" :key="index">
                <!-- <img class="image_5" :src="item.url" /> -->
                <van-image class="image_5" :src="item.url" @click="showFullscreenImage(index)" />
                <span class="font_1 text_5">{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 图表 -->
        <Echart key="1" id="main1" title="根系面积变化趋势" />
        <Echart key="2" id="main2" title="根系长度变化趋势" />
        <Echart key="3" id="main3" title="根系直径变化趋势" />

        <div class="flex-col justify-start items-center button_2 text-wrapper" @click="handleBack">
          <span class="font_1 text_11">返回</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ImagePreview } from 'vant';
import Echart from "./echarts.vue"

export default {
  components: { Echart },
  data () {
    return {
      no: null,
      items: [
        { key: "", label: "描根图", url: require("../../../assets/images/gen_root1.jpg"), namePrefix: 'binary' },
        { key: "", label: "骨架图", url: require("../../../assets/images/gen_root2.jpg"), namePrefix: 'markers' },
        { key: "", label: "二值化图", url: require("../../../assets/images/gen_root3.jpg"), namePrefix: 'depict' },
        { key: "", label: "各根系面积标记图", url: require("../../../assets/images/gen_root4.jpg"), namePrefix: 'skeleton' },
      ],
    }
  },

  mounted () {
    const no = localStorage.getItem("no")
    this.no = no

    this.getData()
  },

  methods: {
    async getData () {
      await this.$api.getCameraPicture({
        gatewayNo: this.no,
        page: 1,
        pageSize: 10
      });
    },

    showFullscreenImage (index) {
      const imgs = this.items.map(item => window.location.origin + item.url)
      ImagePreview({
        images: imgs,
        startPosition: index,
        fullScreen: true, // 打开全屏展示
      });
    },

    handleBack () {
      console.log("111:", this.$router);
      this.$router.back()
    },

    formatImgUrl (folder, namePrefix, imgName) {
      const imgPrefix = `/iotUser-api/camera/${folder}/${namePrefix}-${imgName}`;
      return imgPrefix
    },

  }
}
</script>

<style lang="scss" scoped>
@import "./../codeFunCommon.scss";

.page {
  background-color: #f7f7f7;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  // height: 100%;
}
.group_3 {
  padding: 14px 0;
  overflow-y: auto;
}
.group_4 {
  padding: 0 10px;
}
.space-x-6 > *:not(:first-child) {
  margin-left: 6px;
}
.section {
  background-image: linear-gradient(180deg, #56a0fb 0%, #3776f6 100%);
  border-radius: 20px;
  width: 4px;
  height: 15px;
}
.font_1 {
  font-size: 16px;
  font-family: PingFang SC;
  line-height: 15px;
  color: #333333;
}
.text_3 {
  font-weight: 700;
}
.section_2 {
  background-color: #ffaa00;
  border-radius: 50%;
  width: 6px;
  height: 6px;
}
.text_4 {
  color: #808d9e;
  font-size: 12px;
  font-family: PingFang SC;
  line-height: 11px;
}
.space-y-12 > *:not(:first-child) {
  margin-top: 12px;
}
.list-item {
  padding: 16px 0;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 10.5px 31px #3981f60d;
}
.image_5 {
  border-radius: 4px;
  filter: drop-shadow(0px 2px 5px #2527260d);
  width: 330px;
  height: 198px;
}
.text_5 {
  line-height: 14.5px;
}
.space-y-14 > *:not(:first-child) {
  margin-top: 14px;
}
.button_2 {
  margin: 46px 24px 0;
}
.text-wrapper {
  padding: 16px 0;
  background-image: linear-gradient(90deg, #4877e9 0%, #194cc9 101%);
  border-radius: 30px;
}
.text_11 {
  color: #ffffff;
  line-height: 14.5px;
  letter-spacing: 5.5px;
}
</style>
